import '@babel/polyfill';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import 'mutationobserver-shim';
import 'ol/ol.css';
import Vue from 'vue';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import App from './App.vue';
import './plugins/bootstrap-vue';
import './registerServiceWorker';
import router from './router';
import './styles/app.less';
import './styles/vue-select-override.less';
import { contexteServiceInstance, ContextService } from '@/services/ContextService';
import * as Sentry from "@sentry/vue";
import EventBus, { EVENTS } from './services/EventBus';
Vue.component('v-select', vSelect);


Vue.use(CKEditor);
Vue.config.productionTip = false;
Vue.config.devtools = true;
console.log('init error Handler');

contexteServiceInstance.init();
Vue.config.errorHandler = (err, vm, info) => {
  // err: error trace
  // vm: component in which error occured
  // info: Vue specific error information such as lifecycle hooks, events etc.
  // TODO: Perform any custom logic or log to server test
  console.log(err);
};
window.onerror = function (message, source, lineno, colno, error) {
  console.log(message);
};

EventBus.$on(EVENTS.CONFIG_LOADED, (config:any) => {
  if(config.sentry){
    Sentry.init({
      Vue,
      dsn: "https://fe36a8e92926fd527236a84b2b078d07@sentry.neogeo.fr/36",
      integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration(),
      ],
      // Tracing
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
  }
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
